import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

/**
 * Inicializa o App Check no app Firebase — SOMENTE se o site key reCAPTCHA v3
 * estiver definido em `VITE_APPCHECK_RECAPTCHA_KEY`. Sem a chave, é no-op
 * (inerte): o código já fica pronto e só passa a valer quando você criar o
 * site key no Console Firebase.
 *
 * Rollout: criar reCAPTCHA v3 (Console) → definir a env → deixar App Check em
 * modo MONITORADO alguns dias → só então ativar enforcement no Firestore/Functions.
 * Ver docs/PLANO-HARDENING-F4-PROTECAO-BORDA.md
 *
 * @param {import("firebase/app").FirebaseApp} app
 * @returns {import("firebase/app-check").AppCheck | null}
 */
export function initAppCheck(app) {
  const siteKey = import.meta.env.VITE_APPCHECK_RECAPTCHA_KEY;
  if (!siteKey) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.info("[AppCheck] inativo (VITE_APPCHECK_RECAPTCHA_KEY não definido)");
    }
    return null;
  }
  try {
    // Debug token em dev: permite localhost sem reCAPTCHA real quando
    // VITE_APPCHECK_DEBUG=true (o Firebase imprime um token para registrar no Console).
    if (import.meta.env.DEV && import.meta.env.VITE_APPCHECK_DEBUG === "true") {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
    // eslint-disable-next-line no-console
    console.info("[AppCheck] inicializado");
    return appCheck;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("[AppCheck] falha ao inicializar:", err?.message || err);
    return null;
  }
}
